// extracted by mini-css-extract-plugin
export default {"videoplayer":"index-module__videoplayer--SjhSY"};